function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDownLong = function SvgArrowDownLong(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8 8",
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6.794 4.064a.8.8 0 0 1-.058 1.13L4 7.662 1.264 5.194a.8.8 0 1 1 1.072-1.188l.864.78V1.2a.8.8 0 0 1 1.6 0v3.586l.864-.78a.8.8 0 0 1 1.13.058Z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgArrowDownLong;